import React, { useEffect, useState } from 'react';
import FactviewLogo from '../../images/FactviewLogo.png';
import '../../css/header.css';
import ProfileComponent from '../utilities/ProfileComponent.js';
import LanguageComponent from '../utilities/LanguageComponent.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCurrentUser, getAppUser, getUserById } from '../../functions/utils.js'; // Import the utility function

// Add the icons you will use to the library
library.add(faArrowLeft);

function Header() {
  const [user, setUser] = useState([]);
  
  useEffect(() =>{
    checkDevUser();
  }, []); // [] makes sure that this useEffect block only runs on the first render of the component
  
  useEffect(() =>{
  }, [user]);

  async function checkDevUser(){
    var user = await getUserById();
    if(user){
      setUser(user);
    }
    else{
      setTimeout(function(){
        return checkDevUser();
      }, 500);
    }
  }

  async function navigateFactviewAI(){
    window.location.href = 'https://factview.ai';
  }

  return (
      <header className="app-header">
        <div className="app-top-bar">
          <img src={FactviewLogo} className="header-img" alt="logo" />
          <div className="header-title">
            <p>Import Module</p>
          </div>
          <div className="header-options">
            <div className="language-container">
              <LanguageComponent></LanguageComponent>
            </div>
            <div className="profile-container">
              <ProfileComponent></ProfileComponent>
            </div>
          </div>
        </div>
        {(user && user.import_ai != '0' && 
          <div className="nav-factview-ai">
            <button className="import-btn hover" onClick={navigateFactviewAI}><FontAwesomeIcon icon={faArrowLeft}/>Terug naar Factview AI</button>
          </div>
        )}
      </header >
  );
}

export default Header;
